
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


//importando bootstrap y bootstrap-vue
//BootstrapVueIcons,
import { BootstrapVue, IconsPlugin  } from 'bootstrap-vue'
import  'bootstrap/dist/css/bootstrap.css'
import  'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)


Vue.use(require('vue-moment'));

import axios from 'axios'
import VueAxios from 'vue-axios'
import './registerServiceWorker'
Vue.use(VueAxios, axios)
window.axios = axios

axios.defaults.baseURL = 'https://testserviciolecturamovil.syscoop.com.bo/api';
// axios.defaults.baseURL = 'https://serviciolecturamovil.syscoop.com.bo/api';
// axios.defaults.baseURL = 'http://192.168.100.109:8000/api';
// axios.defaults.baseURL = 'http://127.0.0.1:8000/api';  

var token = localStorage.getItem('token');
axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
//agregar tiempo de ejecucion
// axios.defaults.timeout = 60000; // 10 segundos

Vue.config.productionTip = false; // Se cambio a true para probar si el front levantaba en produccion en produccion

// // regiatra el service worker
// if ('serviceWorker' in navigator) {
//   console.log('====> si puedes usar service worker');
//     navigator.serviceWorker.register('/service_worker.js');
//             // .then( (reg) => {
//             //     setTimeout(() => {
//             //         	reg.sync.register('posteo-gatitos');
//             //           console.log('se enviarion gfoots de gatiso al server');
//             //     }, 5000);
//             // });

// }





// export default db;




//mostrar alerta de acceso a internet 

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')